import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {CFEDTO} from '../../../models/dtos/CFEDTO';

@Component({
  selector: 'app-datos-anulador',
  templateUrl: './datos-anulador.component.html',
  styleUrls: ['./datos-anulador.component.scss']
})
export class DatosAnuladorComponent implements OnInit {

  constructor(public datosAnuladorComponentMatDialogRef: MatDialogRef<DatosAnuladorComponent>, @Inject(MAT_DIALOG_DATA) public cfeDTO: CFEDTO) { }

  ngOnInit() {
    console.log(this.cfeDTO)
  }

  convertirMilisegundosAFecha(milisegundos: Date): string {
    const fecha = new Date(milisegundos);
    const year = fecha.getFullYear();
    const month = ('0' + (fecha.getMonth() + 1)).slice(-2);
    const day = ('0' + fecha.getDate()).slice(-2);

    const fechaFormateada = `${year}-${month}-${day}`;

    return fechaFormateada;
  }

  close() {
    this.datosAnuladorComponentMatDialogRef.close();
  }

}
